import React, { FunctionComponent } from "react";
import styles from "./NotFoundPage.module.scss";

const NotFoundPage: FunctionComponent = () => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.inner}>
                <span className={styles.tagline}>404</span>
                <h1 className={styles.headline}>Page not found</h1>
            </div>
        </div>
    );
};

export default NotFoundPage;